import i18nFactory from '@yandex-int/i18n';
import { Button } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { formatNumber } from '../../../service/FormatHelpers/FormatHelpers';
import { pluralizeWord } from '../../../service/Pluralize/Pluralize';
import {
    RecommendationCharacter,
    RecommendationType
} from '../../../typings/recommendations';
import { Shape2Icon } from '../../Shape2/Shape2';
import {
    RecommendationCard,
    RecommendationCardView
} from '../RecommendationCard';

import './GroupModerationRecommendationCard.css';
import * as keyset from './GroupModerationRecommendationCard.i18n';

const i18n = i18nFactory(keyset);

interface RecommendationsPopupViewProps {
    character: RecommendationCharacter;
    icon: Shape2Icon;
    view: RecommendationCardView.recommendationsPopup;
    onShow?: (view: RecommendationCardView, type: RecommendationType) => void;
}

interface NormalViewProps {
    character: RecommendationCharacter;
    icon: Shape2Icon;
    view: RecommendationCardView.normal;
    groupsNumber: number;
    groupsPageUrl: string;
    onShow?: (view: RecommendationCardView, type: RecommendationType) => void;
}

export type GroupModerationRecommendationCardProps =
    | RecommendationsPopupViewProps
    | NormalViewProps;

export class GroupModerationRecommendationCard extends React.Component<
    GroupModerationRecommendationCardProps
> {
    render() {
        const { view, character, icon, onShow } = this.props;

        return (
            <RecommendationCard
                icon={icon}
                character={character}
                type={RecommendationType.changeAdGroupForModeration}
                title={this.getTitle()}
                titleHint={this.getTitleHint()}
                view={view}
                isInProgress={false}
                buttons={this.getButtons()}
                onShow={onShow}
            >
                {this.getBody()}
            </RecommendationCard>
        );
    }

    private getTitleHint = (): string => {
        const { view } = this.props;

        switch (view) {
            case RecommendationCardView.normal:
                return i18n('several-group-title-hint');

            case RecommendationCardView.recommendationsPopup:
                return i18n('one-group-title-hint');

            default:
                throw Error(
                    `Не определена подпись для заголовка рекомендации вида ${view}`
                );
        }
    };

    private getTitle = (): string => {
        if (this.props.view === RecommendationCardView.recommendationsPopup) {
            return i18n('simple-title');
        }

        const itemsLength = this.props.groupsNumber;
        const formattedItemsLength = formatNumber(itemsLength);

        if (itemsLength === 1) {
            return i18n('one-group-title', {
                count: formattedItemsLength
            });
        }

        return pluralizeWord(
            [
                i18n('twenty-one-group-title', {
                    count: formattedItemsLength
                }),
                i18n('some-group-title', {
                    count: formattedItemsLength
                }),
                i18n('many-group-title', { count: formattedItemsLength })
            ],
            itemsLength
        );
    };

    private getBody = () => {
        if (this.props.view === RecommendationCardView.recommendationsPopup) {
            return (
                <>
                    <p
                        className={Bem.cls(
                            'group-moderation-recommendaiton-card',
                            'body-text'
                        )}
                    >
                        {i18n('popup-ad-decline-req')}
                    </p>
                    <p
                        className={Bem.cls(
                            'group-moderation-recommendaiton-card',
                            'body-text'
                        )}
                    >
                        {i18n('how-to-fix')}
                    </p>
                </>
            );
        }

        return (
            <>
                <p
                    className={Bem.cls(
                        'group-moderation-recommendaiton-card',
                        'body-text'
                    )}
                >
                    {i18n('ad-decline-req')}
                </p>
                <p
                    className={Bem.cls(
                        'group-moderation-recommendaiton-card',
                        'body-text'
                    )}
                >
                    {i18n('open-ad-list')}
                </p>
            </>
        );
    };

    private getButtons = () => {
        if (this.props.view === RecommendationCardView.recommendationsPopup) {
            return undefined;
        }

        const { groupsNumber, groupsPageUrl } = this.props;
        const formattedItemsLength = formatNumber(groupsNumber);

        const buttonText = pluralizeWord(
            [
                i18n('show-one-group-button', {
                    count: formattedItemsLength
                }),
                i18n('show-some-group-button', {
                    count: formattedItemsLength
                }),
                i18n('show-many-group-button', {
                    count: formattedItemsLength
                })
            ],
            groupsNumber
        );

        return [
            <Button
                key={1}
                theme={'action'}
                size={'n'}
                text={buttonText}
                type={'link'}
                url={groupsPageUrl}
            />
        ];
    };
}
